import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageEsLite() {
    return (
        <div className="privacy-policy-container">
 <h1>Política de Privacidad de Tasbih Dhikr Lite</h1>
      <p>Última actualización: 31 de enero de 2024</p>

      <h2>Introducción</h2>
      <p>Bienvenido a la aplicación Tasbih Dhikr Lite. Esta política de privacidad tiene como objetivo informarle sobre cómo manejamos sus datos cuando utiliza nuestra aplicación. La única recopilación de datos en esta aplicación se lleva a cabo por AdMob, un servicio de publicidad de Google, y no recopilamos datos personales activamente.</p>

      <h2>1. Recolección y Uso de Sus Datos Personales</h2>
      <h3>a. Tipos de Datos Recopilados</h3>
      <h4>i. Uso de Datos a través de AdMob</h4>
      <p>Nuestra aplicación utiliza AdMob para mostrar anuncios. AdMob puede recopilar datos como su dirección IP, el identificador de su dispositivo e información sobre su uso de la aplicación. Estos detalles se utilizan para proporcionar y mejorar la experiencia publicitaria.</p>

      <h3>b. Uso de Datos</h3>
      <p>Los datos recopilados por AdMob se utilizan para:</p>
      <ul>
        <li>Proporcionar y personalizar anuncios dentro de la aplicación.</li>
        <li>Análisis de la eficacia de los anuncios mostrados.</li>
      </ul>

      <h3>c. Control por el Usuario</h3>
      <p>Usted puede controlar el uso de sus datos para publicidad personalizada a través de la configuración de su dispositivo.</p>

      <h2>2. Transferencia de Datos</h2>
      <p>Sus datos pueden ser transferidos y mantenidos en computadoras ubicadas fuera de su estado, provincia o país donde las leyes de protección de datos pueden diferir.</p>

      <h2>3. Divulgación de Sus Datos Personales</h2>
      <p>Los datos recopilados por AdMob pueden ser compartidos de acuerdo con la política de privacidad de Google y requisitos legales.</p>

      <h2>4. Seguridad de Sus Datos Personales</h2>
      <p>La seguridad de sus datos es importante para nosotros. Sin embargo, ningún método de transmisión por Internet o de almacenamiento electrónico es 100% seguro.</p>

      <h2>5. Enlaces a Otros Sitios</h2>
      <p>Nuestro servicio puede contener enlaces a otros sitios. Si hace clic en un enlace de terceros, será dirigido al sitio de ese tercero.</p>

      <h2>6. Cambios en Esta Política de Privacidad</h2>
      <p>Podemos actualizar nuestra política de privacidad de vez en cuando. Le notificaremos cualquier cambio publicando la nueva política de privacidad en esta página.</p>

      <h2>7. Contáctenos</h2>
      <p>Si tiene alguna pregunta sobre esta política de privacidad, por favor contáctenos.</p>

      <h2>Enlaces Útiles</h2>
      <p><a href="https://policies.google.com/privacy">Política de Privacidad de Google</a></p>
    </div>
    );
}

export default PrivacyPolicyPageEsLite;
